"use client"
import dynamic from "next/dynamic"
import { GraphQL_DeviceType } from "./product-main"
import { Cart } from "@/server/api/cartActions"
import SkeletonLoader from "./product-skeleton"

const DynamicDeviceSecx = dynamic(
  () => import("./device-secx").then((mod) => mod.DeviceSecx),
  { ssr: false, loading: () => <SkeletonLoader /> }
)

export default function DeviceSecxWrapper({
  data,
  cart,
  onClick,
  id,
}: {
  id: string
  data: GraphQL_DeviceType
  cart: Cart
  onClick: () => void
}) {
  return <DynamicDeviceSecx cart={cart} data={data} id={id} onClick={onClick} />
}
